import { Component, OnInit } from '@angular/core';
import { ProcessService } from '../../../services';

@Component({
    standalone: false,
    selector: 'app-processes-status',
    templateUrl: './processes-status.component.html',
    styleUrls: ['./processes-status.component.scss']
})
export class ProcessesStatusComponent implements OnInit {

    constructor(
        readonly processService: ProcessService
    ) { }

    ngOnInit(): void { }

}
